import AirplaneTiltedOutlineIcon from "@/Components/Icons/AirplaneTiltedOutlineIcon.vue";
import AquariusIcon from "@/Components/Icons/ZodiacSymbols/AquariusIcon.vue";
import AriesIcon from "@/Components/Icons/ZodiacSymbols/AriesIcon.vue";
import AttitudeIcon from "@/Components/Icons/MatchResults/AttitudeIcon.vue";
import BabyOutlineIcon from "@/Components/Icons/BabyOutlineIcon.vue";
import BabyStrollerIcon from "@/Components/Icons/BabyStrollerIcon.vue";
import BasketballIcon from "@/Components/Icons/BasketballIcon.vue";
import CancerIcon from "@/Components/Icons/ZodiacSymbols/CancerIcon.vue";
import CameraSolidIcon from "@/Components/Icons/CameraSolidIcon.vue";
import CapricornIcon from "@/Components/Icons/ZodiacSymbols/CapricornIcon.vue";
import ChatLineIcon from "@/Components/Icons/ChatLineIcon.vue";
import CheckListMinimalisticIcon from "@/Components/Icons/SelectProductFeatures/CheckListMinimalisticIcon.vue";
import ChurchIcon from "@/Components/Icons/ChurchIcon.vue";
import CircleMailIcon from "@/Components/Icons/CircleMailIcon.vue";
import CirclePhoneIcon from "@/Components/Icons/CirclePhoneIcon.vue";
import CocktailIcon from "@/Components/Icons/CocktailIcon.vue";
import CoffeeIcon from "@/Components/Icons/CoffeeIcon.vue";
import CommentIcon from "@/Components/Icons/CommentIcon.vue";
import COUNTRY_FLAGS from "@/Components/Icons/CountryFlags";
import CupStarIcon from "@/Components/Icons/CupStarIcon.vue";
import DangerIcon from "@/Components/Icons/DangerIcon.vue";
import DialogIcon from "@/Components/Icons/SelectProductFeatures/DialogIcon.vue";
import DogLeashedIcon from "@/Components/Icons/DogLeashedIcon.vue";
import DOMAIN_ICONS from "@/Components/Icons/DomainIcons";
import EatingAndDrinkingIcon from "@/Components/Icons/MatchResults/EatingAndDrinkingIcon.vue";
import EducationForm from "@/Components/Forms/Onboarding/EducationForm.vue";
import EducationIcon from "@/Components/Icons/EducationIcon.vue";
import ExclusiveMessageIcon from "@/Components/Icons/ExclusiveMessageIcon.vue";
import GeminiIcon from "@/Components/Icons/ZodiacSymbols/GeminiIcon.vue";
import GlobeOutlineIcon from "@/Components/Icons/GlobeOutlineIcon.vue";
import HandHeartIcon from "@/Components/Icons/HandHeartIcon.vue";
import HandshakeIcon from "@/Components/Icons/HandshakeIcon.vue";
import HandsHeartIcon from "@/Components/Icons/HandsHeartIcon.vue";
import HandStarsIcon from "@/Components/Icons/HandStarsIcon.vue";
import HeartCircleIcon from "@/Components/Icons/HeartCircleIcon.vue";
import HeartHomeIcon from "@/Components/Icons/HeartHomeIcon.vue";
import HeartQuestionOutlineIcon from "@/Components/Icons/HeartQuestionOutlineIcon.vue";
import HeartShineIcon from "@/Components/Icons/SelectProductFeatures/HeartShineIcon.vue";
import HeightIcon from "@/Components/Icons/HeightIcon.vue";
import IncomingCallIcon from "@/Components/Icons/IncomingCallIcon.vue";
import InfoSquareIcon from "@/Components/Icons/InfoSquareIcon.vue";
import interestsIcons from "@/Components/Icons/Interests/index.js";
import InterestsIcon from "@/Components/Icons/MatchResults/InterestsIcon.vue";
import KidsDesireForm from "@/Components/Forms/Onboarding/KidsDesireForm.vue";
import KidsForm from "@/Components/Forms/Onboarding/KidsForm.vue";
import LanguageForm from "@/Components/Forms/Onboarding/LanguageForm.vue";
import LeisureTimeIcon from "@/Components/Icons/MatchResults/LeisureTimeIcon.vue";
import LeoIcon from "@/Components/Icons/ZodiacSymbols/LeoIcon.vue";
import LibraIcon from "@/Components/Icons/ZodiacSymbols/LibraIcon.vue";
import LightBulbIcon from "@/Components/Icons/SelectProductFeatures/LightBulbIcon.vue";
import LikeIcon from "@/Components/Icons/LikeIcon.vue";
import LightningBoltGoldIcon from "@/Components/Icons/LightningBoltGoldIcon.vue";
import LightningBoltIcon from "@/Components/Icons/LightningBoltIcon.vue";
import { LightningBoltIcon as LightningBoltIconSolid } from "@heroicons/vue/solid";
import LivingIcon from "@/Components/Icons/MatchResults/LivingIcon.vue";
import LockIcon from "@/Components/Icons/LockIcon.vue";
import MaritalStatusForm from "@/Components/Forms/Onboarding/MaritalStatusForm.vue";
import MeditationIcon from "@/Components/Icons/SelectProductFeatures/MeditationIcon.vue";
import PencilIcon from "@/Components/Icons/Interests/PencilIcon.vue";
import PetsForm from "@/Components/Forms/Onboarding/PetsForm.vue";
import PhotoIcon from "@/Components/Icons/PhotoIcon.vue";
import PhotosIcon from "@/Components/Icons/PhotosIcon.vue";
import PiscesIcon from "@/Components/Icons/ZodiacSymbols/PiscesIcon.vue";
import PuzzleIcon from "@/Components/Icons/PuzzleIcon.vue";
import QuestionMarkInCircleIcon from "@/Components/Icons/QuestionMarkInCircleIcon.vue";
import ReligionForm from "@/Components/Forms/Onboarding/ReligionForm.vue";
import RelationshipDesignIcon from "@/Components/Icons/MatchResults/RelationshipDesignIcon.vue";
import RingsWeddingIcon from "@/Components/Icons/RingsWeddingIcon.vue";
import RisingStarIcon from "@/Components/Icons/RisingStarIcon.vue";
import RoseIcon from "@/Components/Icons/RoseIcon.vue";
import RunningPersonIcon from "@/Components/Icons/RunningPersonIcon.vue";
import SagittariusIcon from "@/Components/Icons/ZodiacSymbols/SagittariusIcon.vue";
import ScaleIcon from "@/Components/Icons/ScaleIcon.vue";
import ScorpioIcon from "@/Components/Icons/ZodiacSymbols/ScorpioIcon.vue";
import SELECT_PRODUCT_FEATURES_ICONS from "@/Components/Icons/SelectProductFeatures";
import SHARE_ICONS from "@/Components/Icons/ShareIcons";
import SmileIcon from "@/Components/Icons/SmileIcon.vue";
import SmokingHabitForm from "@/Components/Forms/Onboarding/SmokingHabitForm.vue";
import SmokingIcon from "@/Components/Icons/SmokingIcon.vue";
import SoupIcon from "@/Components/Icons/SoupIcon.vue";
import SpeechBubbleOutlineIcon from "@/Components/Icons/SpeechBubbleOutlineIcon.vue";
import SportRegularityForm from "@/Components/Forms/Onboarding/SportRegularityForm.vue";
import StarIcon from "@/Components/Icons/StarIcon.vue";
import StylizedHeartIcon from "@/Components/Icons/StylizedHeartIcon.vue";
import StylizedRoseIcon from "@/Components/Icons/StylizedRoseIcon.vue";
import SwanDarkIcon from "@/Components/Icons/SwanDarkIcon.vue";
import SwanIcon from "@/Components/Icons/SwanIcon.vue";
import TaurusIcon from "@/Components/Icons/ZodiacSymbols/TaurusIcon.vue";
import UserCogIcon from "@/Components/Icons/UserCogIcon.vue";
import UserOnCardsIcon from "@/Components/Icons/UserOnCardsIcon.vue";
import ValuesIcon from "@/Components/Icons/MatchResults/ValuesIcon.vue";
import VirgoIcon from "@/Components/Icons/ZodiacSymbols/VirgoIcon.vue";
import WavingHandIcon from "@/Components/Icons/WavingHandIcon.vue";
import WavingHandInChatBubbleIcon from "@/Components/Icons/WavingHandInChatBubbleIcon.vue";
import WhatsAppLogo from "@/Components/Icons/WhatsappLogo.vue";
import { markRaw } from "vue";
import { range } from "lodash";
import { router } from "@inertiajs/vue3";
import { useGrid } from "vue-screen";
import i18n from "@/Plugins/i18n";

const { t } = i18n.global;
const grid = useGrid("tailwind");

const toOptions = (path, options) =>
    options.map((key) => ({
        text: t(`${path.endsWith("_") ? path : path + "."}${key}`),
        value: key,
    }));

const ROUTES = Object.freeze({
    ADVISOR: {
        TIPS: "/ratgeber/lemonswan-tipps/online-profil/",
        PARTNER_SEARCH: "/ratgeber/lemonswan-tipps/sucheinstellungen/",
        CONTACT: "/ratgeber/lemonswan-tipps/erste-nachricht/",
        FIRST_DATES: "/ratgeber/erstes-date/",
        SINGLES: "/ratgeber/single-staedte/",
        INTERVIEWS: "/ratgeber/experteninterview/",
    },
});

const EMAIL_PROVIDERS = [
    {
        text: "Zu Gmail",
        value: "gmail",
        link: "https://mail.google.com/mail/u/#search/from%3A(news@lemonswan.com)",
        prependIcon: markRaw(DOMAIN_ICONS.GmailIcon),
    },
    {
        text: "Zu Gmail",
        value: "googlemail",
        link: "https://gmail.com/",
        prependIcon: markRaw(DOMAIN_ICONS.GmailIcon),
    },
    {
        text: "Zu Web.de",
        value: "web",
        link: "https://web.de/",
        prependIcon: markRaw(DOMAIN_ICONS.WebDeIcon),
    },
    {
        text: "Zu Outlook",
        value: "outlook",
        link: "https://login.live.com/",
        prependIcon: markRaw(DOMAIN_ICONS.OutlookIcon),
    },
    {
        text: "Zu Hotmail",
        value: "hotmail",
        link: "https://login.live.com/",
        prependIcon: markRaw(DOMAIN_ICONS.OutlookIcon),
    },
    {
        text: "Zu MSN",
        value: "msn",
        link: "https://login.live.com/",
        prependIcon: markRaw(DOMAIN_ICONS.OutlookIcon),
    },
    {
        text: "Zu Yahoo",
        value: "yahoo",
        link: "https://login.yahoo.com/",
        prependIcon: markRaw(DOMAIN_ICONS.YahooIcon),
    },
    {
        text: "Zu freenet",
        value: "freenet",
        link: "https://www.freenet.de/",
        prependIcon: markRaw(DOMAIN_ICONS.FreenetIcon),
    },
    {
        text: "Zu t-online",
        value: "t-online",
        link: "https://email.t-online.de/",
        prependIcon: markRaw(DOMAIN_ICONS.TOnlineIcon),
    },
    {
        text: "Zu Magenta",
        value: "magenta",
        link: "https://email.t-online.de/",
        prependIcon: markRaw(DOMAIN_ICONS.TOnlineIcon),
    },
    {
        text: "Zu GMX",
        value: "gmx",
        link: "https://www.gmx.net/",
        prependIcon: markRaw(DOMAIN_ICONS.GmxIcon),
    },
    {
        text: "Zu Aol",
        value: "aol",
        link: "https://login.aol.com/",
        prependIcon: markRaw(DOMAIN_ICONS.AolIcon),
    },
    {
        text: "Zu Apple Mail",
        value: "icloud",
        link: "https://www.icloud.com/mail",
        prependIcon: markRaw(DOMAIN_ICONS.AppleMailIcon),
    },
    {
        text: "Zu mail.com",
        value: "mail",
        link: "https://www.mail.com/",
        prependIcon: markRaw(DOMAIN_ICONS.MailComIcon),
    },
];

const MESSENGER_AND_EMAIL_LINKS = [
    {
        network: "email",
        label: t("referral_area.sharing.modal.icon_labels.email"),
        prependIcon: markRaw(SHARE_ICONS.LetterInCircleIcon),
    },
    {
        network: "whatsapp",
        label: t("referral_area.sharing.modal.icon_labels.whats_app"),
        prependIcon: markRaw(SHARE_ICONS.WhatsappLogo),
    },
    {
        network: "messenger",
        label: t("referral_area.sharing.modal.icon_labels.messenger"),
        prependIcon: markRaw(SHARE_ICONS.FacebookMessengerIcon),
        directUrl: "https://www.messenger.com/",
    },
    // {
    //     network: "sms",
    //     label: t("referral_area.sharing.modal.icon_labels.sms"),
    //     prependIcon: markRaw(SHARE_ICONS.CirclePhoneIcon),
    // },
];

const SOCIAL_MEDIA_LINKS = [
    {
        network: "facebook",
        label: t("referral_area.sharing.modal.icon_labels.facebook"),
        prependIcon: markRaw(SHARE_ICONS.FacebookIcon),
    },
    // {
    //     network: "instagram",
    //     label: t("referral_area.sharing.modal.icon_labels.instagram"),
    //     prependIcon: markRaw(SHARE_ICONS.InstagramLogo),
    // },
];

const OPTIONS = Object.freeze({
    GENDERS: {
        MALE: "male",
        FEMALE: "female",
    },
    COUNTRIES: (showCode = false) => {
        return [
            {
                text:
                    t("generic.ls_generic_country_germany") +
                    (showCode ? " (+49)" : ""),
                value: "DE",
                prependIcon: markRaw(COUNTRY_FLAGS.GermanyFlagIcon),
            },
            {
                text:
                    t("generic.ls_generic_country_austria") +
                    (showCode ? " (+43)" : ""),
                value: "AT",
                prependIcon: markRaw(COUNTRY_FLAGS.AustriaFlagIcon),
            },
            {
                text:
                    t("generic.ls_generic_country_switzerland") +
                    (showCode ? " (+41)" : ""),
                value: "CH",
                prependIcon: markRaw(COUNTRY_FLAGS.SwitzerlandFlagIcon),
            },
            {
                text:
                    t("generic.ls_generic_country_luxembourg") +
                    (showCode ? " (+352)" : ""),
                value: "LU",
                prependIcon: markRaw(COUNTRY_FLAGS.LuxembourgFlagIcon),
            },
            {
                text:
                    t("generic.ls_generic_country_belgium") +
                    (showCode ? " (+32)" : ""),
                value: "BE",
                prependIcon: markRaw(COUNTRY_FLAGS.BelgiumFlagIcon),
            },
            {
                text:
                    t("generic.ls_generic_country_netherlands") +
                    (showCode ? " (+31)" : ""),
                value: "NL",
                prependIcon: markRaw(COUNTRY_FLAGS.NetherlandsFlagIcon),
            },
            {
                text:
                    t("generic.ls_generic_country_spain") +
                    (showCode ? " (+34)" : ""),
                value: "ES",
                prependIcon: markRaw(COUNTRY_FLAGS.SpainFlagIcon),
            },
        ];
    },
    RULE_AREAS: () => {
        return [
            {
                text: "Frontend",
                value: "frontend",
            },
            {
                text: "Backend",
                value: "backend",
            },
        ];
    },
    COUNTRY_CODES: () => {
        return [
            {
                text: "DE",
                value: "DE",
            },
            {
                text: "AT",
                value: "AT",
            },
            {
                text: "CH",
                value: "CH",
            },
            {
                text: "LU",
                value: "LU",
            },
            {
                text: "BE",
                value: "BE",
            },
            {
                text: "NL",
                value: "NL",
            },
            {
                text: "ES",
                value: "ES",
            },
        ];
    },
    COUNTRY_PREFIXES: () => {
        return [
            {
                text: "(+49)",
                value: "DE",
                prependIcon: markRaw(COUNTRY_FLAGS.GermanyFlagIcon),
            },
            {
                text: "(+43)",
                value: "AT",
                prependIcon: markRaw(COUNTRY_FLAGS.AustriaFlagIcon),
            },
            {
                text: "(+41)",
                value: "CH",
                prependIcon: markRaw(COUNTRY_FLAGS.SwitzerlandFlagIcon),
            },
            {
                text: "(+352)",
                value: "LU",
                prependIcon: markRaw(COUNTRY_FLAGS.LuxembourgFlagIcon),
            },
            {
                text: "(+32)",
                value: "BE",
                prependIcon: markRaw(COUNTRY_FLAGS.BelgiumFlagIcon),
            },
            {
                text: "(+31)",
                value: "NL",
                prependIcon: markRaw(COUNTRY_FLAGS.NetherlandsFlagIcon),
            },
            {
                text: "(+34)",
                value: "ES",
                prependIcon: markRaw(COUNTRY_FLAGS.SpainFlagIcon),
            },
        ];
    },
    INCOME: (currency = "EUR") => {
        return [
            {
                text: t("generic.ls_generic_income_less_than", {
                    to: "15.000",
                    currency: currency,
                }),
                value: "15,000",
                from: 0,
                to: 15000,
            },
            {
                text: t("generic.ls_generic_income_from_to", {
                    from: "15.000",
                    to: "25.000",
                    currency: currency,
                }),
                value: "15,000 to 25,000",
                from: 15000,
                to: 25000,
            },
            {
                text: t("generic.ls_generic_income_from_to", {
                    from: "25.000",
                    to: "35.000",
                    currency: currency,
                }),
                value: "25,000 to 35,000",
                from: 25000,
                to: 35000,
            },
            {
                text: t("generic.ls_generic_income_from_to", {
                    from: "35.000",
                    to: "50.000",
                    currency: currency,
                }),
                value: "35,000 to 50,000",
                from: 35000,
                to: 50000,
            },
            {
                text: t("generic.ls_generic_income_from_to", {
                    from: "50.000",
                    to: "100.000",
                    currency: currency,
                }),
                value: "50,000 to 100,000",
                from: 50000,
                to: 100000,
            },
            {
                text: t("generic.ls_generic_income_over", {
                    from: "100.000",
                    currency: currency,
                }),
                value: "100,000",
                from: 100000,
                to: 250000,
            },
        ];
    },
    OCCUPATION: [
        "self_employed",
        "official",
        "housekeeper",
        "pensioner",
        "student",
        "others",
    ],
    SERVICE_CENTER_LINKS: [
        {
            title: t("support.contact_form.headline_zendesk"),
            icon: markRaw(ChatLineIcon),
            url: route("user.settings.support.contact"),
            external: false,
        },
        {
            title: t("support.recall_service.headline"),
            icon: markRaw(IncomingCallIcon),
            url: route("user.settings.support.recall"),
            external: false,
        },
        {
            title: t("support.FAQ.link"),
            icon: markRaw(InfoSquareIcon),
            url: "https://help.lemonswan.de/hc/de",
            external: true,
        },
    ],
    SELF_SERVICE_HELP_CENTER_LINKS: [
        {
            title: t("support.contact_form.headline_zendesk"),
            icon: markRaw(ChatLineIcon),
            url: route("self-service.help-center.contact"),
        },
        {
            title: t("support.recall_service.headline"),
            icon: markRaw(IncomingCallIcon),
            url: route("self-service.help-center.recall"),
        },
        {
            title: t("support.FAQ.link"),
            icon: markRaw(InfoSquareIcon),
            url: "https://help.lemonswan.de/hc/de",
        },
    ],
    CONTACT_CATEGORIES: [
        {
            text: t("support.categories.category_1"),
            value: "category_1",
        },
        {
            text: t("support.categories.category_2"),
            value: "category_2",
        },
        {
            text: t("support.categories.category_3"),
            value: "category_3",
        },
        {
            text: t("support.categories.category_4"),
            value: "category_4",
        },
        {
            text: t("support.categories.category_5"),
            value: "category_5",
        },
        {
            text: t("support.categories.category_6"),
            value: "category_6",
        },
        {
            text: t("support.categories.category_7"),
            value: "category_7",
        },
    ],
    WEEKDAYS: [
        {
            text: t("generic.weekday_1"),
            value: "monday",
        },
        {
            text: t("generic.weekday_2"),
            value: "tuesday",
        },
        {
            text: t("generic.weekday_3"),
            value: "wednesday",
        },
        {
            text: t("generic.weekday_4"),
            value: "thursday",
        },
        {
            text: t("generic.weekday_5"),
            value: "friday",
        },
    ],
    DEACTIVATE_ACCOUNT_REASONS: [
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason1"
            ),
            value: "need_a_break",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason2"
            ),
            value: "dislike_partner_proposals",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason3"
            ),
            value: "too_few_messages",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason4"
            ),
            value: "no_suitable_premium_offer",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason5"
            ),
            value: "do_not_know_how_to_use_lemonswan",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason6"
            ),
            value: "privacy_concern",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason7"
            ),
            value: "too_many_emails",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_yes_reason8"
            ),
            value: "other",
        },
    ],
    DELETE_ACCOUNT_REASONS: [
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason1"
            ),
            value: "found_partner",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason2"
            ),
            value: "dislike_partner_proposals",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason3"
            ),
            value: "too_few_messages",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason4"
            ),
            value: "no_suitable_premium_offer",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason5"
            ),
            value: "do_not_know_how_to_use_lemonswan",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason6"
            ),
            value: "privacy_concern",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason7"
            ),
            value: "too_many_emails",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_delete_yes_reason8"
            ),
            value: "other",
        },
    ],
    CANCEL_SUBSCRIPTION_REASONS: [
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_subscription_reason_1"
            ),
            value: "found_partner",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_subscription_reason_2"
            ),
            value: "dislike_partner_proposals",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_subscription_reason_3"
            ),
            value: "too_few_messages",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_subscription_reason_4"
            ),
            value: "do_not_know_how_to_use_lemonswan",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_subscription_reason_5"
            ),
            value: "privacy_concern",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_subscription_reason_6"
            ),
            value: "too_many_emails",
        },
        {
            text: t(
                "data_settings.ls_my_profile_data_and_settings_account_deactivate_subscription_reason_7"
            ),
            value: "other",
        },
    ],
    END_CONTRACT_REASONS: [
        {
            text: t("selfservice.end_contract.feedback.form.reasons.1"),
            value: "found_partner",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.2"),
            value: "too_expensive",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.3"),
            value: "dislike_partner_proposals",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.4"),
            value: "too_few_messages",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.5"),
            value: "technical_problems",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.6"),
            value: "do_not_know_how_to_use_lemonswan",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.7"),
            value: "privacy_concern",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.8"),
            value: "too_many_emails",
        },
        {
            text: t("selfservice.end_contract.feedback.form.reasons.9"),
            value: "other",
        },
    ],
    PAYMENT_FREQUENCIES: [
        {
            text: t("paywall.payment_frequency.onetime"),
            value: "onetime",
        },
        {
            text: t("paywall.payment_frequency.monthly"),
            value: "monthly",
            paymentFee: 6.0,
        },
        {
            text: t("paywall.payment_frequency.quarterly"),
            value: "quarterly",
            paymentFee: 4.0,
        },
        {
            text: t("paywall.payment_frequency.semiannually"),
            value: "semiannually",
            paymentFee: 2.0,
        },
    ],
    DESIRE_FOR_CHILDREN: [
        {
            text: t("matching.wants_kids.yes"),
            value: "yes",
        },
        {
            text: t("matching.wants_kids.no"),
            value: "no",
        },
        {
            text: t("matching.wants_kids.basically_conceivable"),
            value: "basically_conceivable",
        },
        {
            text: t("matching.no_matter"),
            value: "no_matter",
        },
    ],
    SPORT_REGULARITY: [
        {
            text: t("characteristics.every_day"),
            value: "daily",
        },
        {
            text: t("characteristics.several_times_a_week"),
            value: "several_times_a_week",
        },
        {
            text: t("characteristics.several_times_a_month"),
            value: "several_times_a_month",
        },
        {
            text: t("characteristics.rarely"),
            value: "rarely",
        },
    ],
    SPORT_TYPES: toOptions("characteristics", [
        "american_football",
        "fishing",
        "badminton",
        "baseball",
        "basketball",
        "mountaineering",
        "bowling",
        "canyoning",
        "cricket",
        "extreme_sport",
        "fitness",
        "formula_one",
        "soccer",
        "golf",
        "gym",
        "hiit",
        "handball",
        "hockey",
        "inlineskating",
        "jogging",
        "martial_art",
        "kanu",
        "kayaking",
        "kitesurfing",
        "athletics",
        "motorsport",
        "mountainbiking",
        "padel_tennis",
        "pickleball",
        "pilates",
        "cycle",
        "horse_ridding",
        "rodeo",
        "rowing",
        "rugby",
        "swim",
        "sailing",
        "skateboarding",
        "ski",
        "snowboarding",
        "sport_shooting",
        "stand_up_paddling",
        "surfing",
        "dance",
        "diving",
        "tennis",
        "table_tennis",
        "triathlon",
        "volleyball",
        "walking",
        "hiking",
        "windsurfing",
        "yoga",
    ]),
    SMOKER: [
        {
            text: t("matching.smoking_habit.smoking"),
            value: "smoking",
        },
        {
            text: t("matching.smoking_habit.none_smoking"),
            value: "none_smoking",
        },
        {
            text: t("matching.smoking_habit.casual_smoking"),
            value: "casual_smoking",
        },
        {
            text: t("matching.smoking_habit.e_cigarette"),
            value: "e_cigarette",
        },
    ],
    HAS_KIDS: [
        {
            text: t("matching.settings_children.yes"),
            value: "yes",
        },
        {
            text: t("matching.settings_children.no"),
            value: "no",
        },
        {
            text: t("matching.no_matter"),
            value: "no_matter",
        },
    ],
    CHILDREN: range(0, 7).map((value) => ({
        value,
        text: t(`generic.kid${value === 6 ? "_more" : ""}`, {
            count: value,
        }),
    })),
    CHILDREN_IN_HOUSEHOLD: range(0, 3).map((value) => ({
        value,
        text: t(`generic.kids_in_house`, { count: value }),
    })),
    TITLES: toOptions("home.profile.titles", [
        "no_title",
        "doctor",
        "professor",
        "engineer",
        "master_of_arts",
        "licentiate",
        "bachelor",
        "magister",
    ]),
    HIGHEST_DEGREE: toOptions("home.profile.degrees", [
        "lower_education",
        "hauptschulabschluss",
        "real_handels_fachschulabschluss",
        "high_school",
        "some_semesters_studied",
        "still_studying",
        "completed_study",
    ]),
    MARITAL_STATUSES: toOptions("home.profile.marital_statuses", [
        "single",
        "divorced",
        "living_separately",
        "widowed",
    ]),

    INCOME_RANGE: [0, 15000, 25000, 35000, 50000, 100000, 250000],
    DISTANCE_RANGE: [25, 35, 55, 90, 140, 240, 380, 600, 980, 999],
    HIGHEST_DEGREE_RANGE: [
        "lower_education",
        "hauptschulabschluss",
        "real_handels_fachschulabschluss",
        "high_school",
        "some_semesters_studied",
        "still_studying",
        "completed_study",
    ],
    ZODIAC_SIGNS: [
        {
            value: "aries",
            text: t("zodiac.ls_lemonswan_zodiac_sign_aries"),
            prependIcon: markRaw(AriesIcon),
        },
        {
            value: "taurus",
            text: t("zodiac.ls_lemonswan_zodiac_sign_taurus"),
            prependIcon: markRaw(TaurusIcon),
        },
        {
            value: "gemini",
            text: t("zodiac.ls_lemonswan_zodiac_sign_gemini"),
            prependIcon: markRaw(GeminiIcon),
        },
        {
            value: "cancer",
            text: t("zodiac.ls_lemonswan_zodiac_sign_cancer"),
            prependIcon: markRaw(CancerIcon),
        },
        {
            value: "leo",
            text: t("zodiac.ls_lemonswan_zodiac_sign_leo"),
            prependIcon: markRaw(LeoIcon),
        },
        {
            value: "virgo",
            text: t("zodiac.ls_lemonswan_zodiac_sign_virgo"),
            prependIcon: markRaw(VirgoIcon),
        },
        {
            value: "libra",
            text: t("zodiac.ls_lemonswan_zodiac_sign_libra"),
            prependIcon: markRaw(LibraIcon),
        },
        {
            value: "scorpio",
            text: t("zodiac.ls_lemonswan_zodiac_sign_scorpio"),
            prependIcon: markRaw(ScorpioIcon),
        },
        {
            value: "sagittarius",
            text: t("zodiac.ls_lemonswan_zodiac_sign_sagittarius"),
            prependIcon: markRaw(SagittariusIcon),
        },
        {
            value: "capricorn",
            text: t("zodiac.ls_lemonswan_zodiac_sign_capricorn"),
            prependIcon: markRaw(CapricornIcon),
        },
        {
            value: "aquarius",
            text: t("zodiac.ls_lemonswan_zodiac_sign_aquarius"),
            prependIcon: markRaw(AquariusIcon),
        },
        {
            value: "pisces",
            text: t("zodiac.ls_lemonswan_zodiac_sign_pisces"),
            prependIcon: markRaw(PiscesIcon),
        },
    ],
    RELIGIONS: toOptions("profile.ls_characteristic_religion_choice_", [
        "christianity",
        "islam",
        "judaism",
        "buddhism",
        "hinduism",
        "other",
        "none",
    ]),
    RELIGIOUS: toOptions("profile.ls_characteristic_religious_choice_", [
        "yes",
        "no",
    ]),
    LANGUAGES: toOptions("profile.ls_characteristic_language_choice_", [
        "ar",
        "cn",
        "da",
        "de",
        "en",
        "fi",
        "fr",
        "gr",
        "it",
        "jp",
        "ku",
        "ld",
        "ma",
        "nl",
        "nb",
        "pl",
        "pt",
        "ru",
        "sv",
        "sd",
        "es",
        "tr",
    ]),
    PETS: toOptions("profile.ls_my_profile_characteristic_pet_", [
        "allergic",
        "amphibian",
        "fish",
        "hamster",
        "dog",
        "rabbit",
        "cat",
        "mouse",
        "guinea_pig",
        "wish",
        "reptile",
        "turtle",
        "bird",
        "none",
    ]),
    NO_MATTER: {
        text: t("matching.no_matter"),
        value: "no_matter",
    },
    HOLIDAY: toOptions("characteristics", [
        "adventure_holidays",
        "fishing_tours",
        "sports_and_activities",
        "rural_tourism",
        "backpacking",
        "swimming_holiday",
        "camping",
        "club_holidays",
        "relaxing",
        "bike_tours",
        "culinaric_tours",
        "group_travel",
        "in_the_mountains",
        "art_and_culture_travel",
        "luxury_travel",
        "meditation",
        "motorcyle_travel",
        "eco_tourism",
        "retreats",
        "roadtrips",
        "safari",
        "cruises",
        "city_breaks",
        "beach_holiday",
        "study_tours",
        "home",
        "vanlife",
        "trekking",
        "beauty_spa_vacation",
        "winter_travel",
        "workation",
    ]),
    FOOD: toOptions("characteristics", [
        "african",
        "american",
        "arabic",
        "asian",
        "bbq",
        "bio",
        "chinese",
        "bourgois",
        "fast_food",
        "flexitarian",
        "french",
        "health_oriented",
        "gluten_free",
        "gourmet",
        "greek",
        "halal",
        "indian",
        "italian",
        "japanese",
        "caribbean",
        "keto",
        "kosher",
        "latin_american",
        "mediterranean",
        "seafood",
        "mexican",
        "oriental",
        "pescetarian",
        "regional",
        "spicy",
        "self_cook",
        "smoothies",
        "street_food",
        "sweet",
        "vegan",
        "vegetarian",
    ]),
    DRINKER: [
        {
            text: t("matching.drinking_habit.yes"),
            value: "yes",
        },
        {
            text: t("matching.drinking_habit.no"),
            value: "no",
        },
        {
            text: t("matching.drinking_habit.occasionally"),
            value: "occasionally",
        },
    ],
    MUSIC: toOptions("characteristics", [
        "blues",
        "chill_out",
        "chansons",
        "country",
        "electro_dance",
        "folk",
        "funk",
        "hip_hop",
        "indie_alternative",
        "jazz",
        "classical",
        "latino",
        "metal_hard_rock",
        "musical",
        "oldies_evergreens",
        "pop",
        "punk",
        "rnb",
        "rock",
        "techno_house",
        "schlager",
        "soul",
        "reggae",
        "folk_music",
    ]),
    INSTRUMENTS: toOptions("characteristics", [
        "accordion",
        "recorder",
        "guitar",
        "keyboard",
        "clarinet",
        "piano",
        "flute",
        "saxophone",
        "drums",
        "trumpet",
        "violin",
        "no_instrument",
    ]),
});

const FEATURES = Object.freeze([
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_1"),
        description: t("paywall.ls_paywall_premium_benefits_text_1"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.ChatIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_2"),
        description: t("paywall.ls_paywall_premium_benefits_text_2"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.GalleryFavoriteIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_3"),
        description: t("paywall.ls_paywall_premium_benefits_text_3"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.ShieldCheckIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_4"),
        description: t("paywall.ls_paywall_premium_benefits_text_4"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.ClipboardIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_5"),
        description: t("paywall.ls_paywall_premium_benefits_text_5"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.HeartShineIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_6"),
        description: t("paywall.ls_paywall_premium_benefits_text_6"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.GenderBalanceIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_7"),
        description: t("paywall.ls_paywall_premium_benefits_text_7"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.TuningIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_8"),
        description: t("paywall.ls_paywall_premium_benefits_text_8"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.MapPointRotateIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_9"),
        description: t("paywall.ls_paywall_premium_benefits_text_9"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.HeartInHeartIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_10"),
        description: t("paywall.ls_paywall_premium_benefits_text_10"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.PartnerProfilesIcon),
    },
    {
        title: t("paywall.ls_paywall_premium_benefits_H2_11"),
        description: t("paywall.ls_paywall_premium_benefits_text_11"),
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.BoltIcon),
    },
]);

const PTRIAL_FEATURES = Object.freeze([
    {
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.ChatIcon),
    },
    {
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.HeartShineIcon),
    },
    {
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.GalleryFavoriteIcon),
    },
    {
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.ClipboardIcon),
    },
    {
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.HeartInHeartIcon),
    },
    {
        icon: markRaw(SELECT_PRODUCT_FEATURES_ICONS.MapPointRotateIcon),
    },
]);

const PREMIUM_INFORMATION = Object.freeze([
    {
        title: t("paywall.ls_paywall_premium_information_tab1_H1"),
        description: t("paywall.ls_paywall_premium_information_tab1_text"),
    },
    {
        title: t("paywall.ls_paywall_premium_information_tab2_H1"),
        description: t("paywall.ls_paywall_premium_information_tab2_text"),
    },
    {
        title: t("paywall.ls_paywall_checkout_benefits_benefit_6"),
        description: t("paywall.ls_paywall_premium_information_tab3_text"),
    },
    {
        title: t("paywall.ls_paywall_checkout_benefits_benefit_5"),
        description: t("paywall.ls_paywall_premium_information_tab4_text"),
    },
]);

const EMAIL_ADDRESSES = Object.freeze({
    SERVICE: "tuersteherinnen@lemonswan.com",
});

const COUNTRY_AREA_CODES = Object.freeze({
    DE: "+49",
    AT: "+43",
    CH: "+41",
    LU: "+352",
});

const APP_CONFIG = Object.freeze({
    NAME: "LemonSwan",
    LOCATION: "Hamburg",
});

const TOAST_STATES = {
    SUCCESS: "success",
    ERROR: "error",
};

const LIMIT_FOR_PHOTOS_UPLOAD = 9;

export const ONBOARDING_STEPS = [
    "analysis",
    "avatar",
    "characteristics",
    "about",
    "write_welcome",
    "photos",
    "identity",
    "status",
];

export const PROFILE_COMPLETION_OVERVIEW_ITEMS = [
    {
        key: "analysis",
        icon: null,
        title: t(
            "home.onboarding.profile_completion_overview_widget.analysis.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.analysis.description"
        ),
    },
    {
        key: "lifestyle",
        icon: markRaw(HeartHomeIcon),
        title: t(
            "home.onboarding.profile_completion_overview_widget.lifestyle.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.lifestyle.description"
        ),
    },
    {
        key: "personal_question",
        icon: markRaw(HeartQuestionOutlineIcon),
        title: t(
            "home.onboarding.profile_completion_overview_widget.personal_queston.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.personal_queston.description"
        ),
    },
    {
        key: "avatar",
        icon: markRaw(CameraSolidIcon),
        title: t(
            "home.onboarding.profile_completion_overview_widget.avatar.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.avatar.description"
        ),
    },
    {
        key: "photos",
        icon: markRaw(PhotoIcon),
        title: t(
            "home.onboarding.profile_completion_overview_widget.photos.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.photos.description"
        ),
    },
    {
        key: "about",
        icon: markRaw(SpeechBubbleOutlineIcon),
        title: t(
            "home.onboarding.profile_completion_overview_widget.lifestyle.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.lifestyle.description"
        ),
    },
    {
        key: "write_welcome",
        icon: markRaw(StarIcon),
        title: t(
            "home.onboarding.profile_completion_overview_widget.write_welcome.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.write_welcome.description"
        ),
    },
    {
        key: "status",
        icon: markRaw(PencilIcon),
        title: t(
            "home.onboarding.profile_completion_overview_widget.status.title"
        ),
        description: t(
            "home.onboarding.profile_completion_overview_widget.status.description"
        ),
    },
];

export const TEST_RESULT_SECTIONS = [
    {
        key: "overview",
        title: t("test_results.ls_my_profile_test_result_section_1"),
        subsection: false,
        icon: HeartShineIcon,
        url: route("user.test-results.overview"),
    },
    {
        key: "openness",
        title: t("test_results.ls_my_profile_test_result_section_2"),
        subsection: true,
        icon: LightBulbIcon,
        url: route("user.test-results.section", "openness"),
    },
    {
        key: "responsibility",
        title: t("test_results.ls_my_profile_test_result_section_3"),
        subsection: true,
        icon: CheckListMinimalisticIcon,
        url: route("user.test-results.section", "responsibility"),
    },
    {
        key: "extraversion",
        title: t("test_results.ls_my_profile_test_result_section_4"),
        subsection: true,
        icon: DialogIcon,
        url: route("user.test-results.section", "extraversion"),
    },
    {
        key: "compatibility",
        title: t("test_results.ls_my_profile_test_result_section_5"),
        subsection: true,
        icon: WavingHandIcon,
        url: route("user.test-results.section", "compatibility"),
    },
    {
        key: "emotionality",
        title: t("test_results.ls_my_profile_test_result_section_6"),
        subsection: true,
        icon: MeditationIcon,
        url: route("user.test-results.section", "emotionality"),
    },
];

export const PARTNER_TEST_RESULT_SECTIONS = (id) => [
    {
        key: "overview",
        title: t("test_results.ls_my_profile_test_result_section_1"),
        subsection: false,
        icon: HeartCircleIcon,
        url: route("partner.test-results.overview", id),
    },
    {
        key: "values",
        title: t("profile.ls_partner_profile_matching_section_3"),
        subsection: true,
        icon: ValuesIcon,
        url: route("partner.test-results.section", [id, "values"]),
        subcategories: [
            "power",
            "performance",
            "hedonism",
            "stimulation",
            "self_determination",
            "universalism",
            "benevolence",
            "tradition",
            "conformity",
            "security",
        ],
    },
    {
        key: "settings",
        title: t("profile.ls_partner_profile_matching_section_7"),
        subsection: true,
        icon: AttitudeIcon,
        url: route("partner.test-results.section", [id, "settings"]),
        subcategories: ["work", "consumption", "love", "society"],
    },
    {
        key: "relationship_creation",
        title: t("profile.ls_partner_profile_matching_section_2"),
        subsection: true,
        icon: RelationshipDesignIcon,
        url: route("partner.test-results.section", [
            id,
            "relationship_creation",
        ]),
    },
    {
        key: "interests",
        title: t("profile.ls_partner_profile_matching_section_4"),
        subsection: true,
        icon: InterestsIcon,
        url: route("partner.test-results.section", [id, "interests"]),
    },
    {
        key: "leisure_time",
        title: t("profile.ls_partner_profile_matching_section_5"),
        subsection: true,
        icon: LeisureTimeIcon,
        url: route("partner.test-results.section", [id, "leisure_time"]),
    },
    {
        key: "lifestyle_living",
        title: t("profile.ls_partner_profile_matching_section_6"),
        subsection: true,
        icon: LivingIcon,
        url: route("partner.test-results.section", [id, "lifestyle_living"]),
    },
    {
        key: "lifestyle_eating_drinking",
        title: t("profile.ls_partner_profile_matching_section_1"),
        subsection: true,
        icon: EatingAndDrinkingIcon,
        url: route("partner.test-results.section", [
            id,
            "lifestyle_eating_drinking",
        ]),
    },
];

export const PARTNER_TEST_RESULT_SECTIONS_REDUCED = [
    {
        key: "values",
        title: t("profile.ls_partner_profile_matching_section_3"),
        icon: ScaleIcon,
    },
    {
        key: "settings",
        title: t("profile.ls_partner_profile_matching_section_7"),
        icon: UserCogIcon,
    },
    {
        key: "relationship_creation",
        title: t("profile.ls_partner_profile_matching_section_2"),
        icon: PuzzleIcon,
    },
    {
        key: "interests",
        title: t("profile.ls_partner_profile_matching_section_4"),
        icon: HandsHeartIcon,
    },
    {
        key: "leisure_time",
        title: t("profile.ls_partner_profile_matching_section_5"),
        icon: CocktailIcon,
    },
    {
        key: "lifestyle_living",
        title: t("profile.ls_partner_profile_matching_section_6"),
        icon: HeartHomeIcon,
    },
    {
        key: "lifestyle_eating_drinking",
        title: t("profile.ls_partner_profile_matching_section_1"),
        icon: CoffeeIcon,
    },
];

export const USER_CHARACTERISTICS = [
    {
        key: "location",
    },
    {
        key: "education",
        label: t("user.profile_overview.characteristic.education.label"),
        icon: EducationIcon,
        options: OPTIONS.HIGHEST_DEGREE,
    },
    {
        key: "marital_status",
        label: t("user.profile_overview.characteristic.marital_status.label"),
        icon: RingsWeddingIcon,
        options: OPTIONS.MARITAL_STATUSES,
    },
    {
        key: "children_number",
        label: t("user.profile_overview.characteristic.children_number.label"),
        icon: BabyStrollerIcon,
        options: OPTIONS.CHILDREN,
    },
    {
        key: "wants_kids",
        label: t("user.profile_overview.characteristic.wants_kids.label"),
        icon: BabyOutlineIcon,
        options: OPTIONS.DESIRE_FOR_CHILDREN,
    },
    {
        key: "height",
        label: t("user.profile_overview.characteristic.height.label"),
        icon: HeightIcon,
    },
    {
        key: "language",
        label: t("user.profile_overview.characteristic.language.label"),
        icon: interestsIcons["SmileyOpenMouthIcon"],
        options: OPTIONS.LANGUAGES,
    },
    {
        key: "religion",
        label: t("user.profile_overview.characteristic.religion.label"),
        icon: ChurchIcon,
        options: OPTIONS.RELIGIONS,
    },
    {
        key: "zodiac_sign",
        label: t("user.profile_overview.characteristic.zodiac"),
    },
];

export const USER_CHARACTERISTICS_EDIT_ITEMS = [
    {
        key: "education",
        title: t("user.profile_overview.characteristic.education.content"),
        icon: EducationIcon,
        options: OPTIONS.HIGHEST_DEGREE,
    },
    {
        key: "title",
        title: null,
        label: null,
        icon: null,
        options: OPTIONS.TITLES,
        visible: (profile) =>
            profile.education.education_highest_degree === "completed_study" ||
            profile.education === "completed_study",
    },
    {
        key: "marital_status",
        title: t("user.profile_overview.characteristic.marital_status.title"),
        icon: RingsWeddingIcon,
        options: OPTIONS.MARITAL_STATUSES,
    },
    {
        key: "children_number",
        title: t("user.profile_overview.characteristic.children_number.title"),
        icon: BabyStrollerIcon,
        options: OPTIONS.CHILDREN,
    },
    {
        key: "children_number_in_household",
        title: t(
            "user.profile_overview.characteristic.children_number_in_household.title"
        ),
        icon: BabyStrollerIcon,
        options: OPTIONS.CHILDREN,
        visible: (profile) => profile.children_number > 0,
    },
    {
        key: "wants_kids",
        title: t("user.profile_overview.characteristic.wants_kids.title"),
        icon: BabyOutlineIcon,
        options: OPTIONS.DESIRE_FOR_CHILDREN,
    },
    {
        key: "language_popular",
        title: t("user.profile_overview.characteristic.language.title"),
        icon: interestsIcons["SmileyOpenMouthIcon"],
        options: OPTIONS.LANGUAGES,
    },
    {
        key: "religious",
        title: t("user.profile_overview.characteristic.religious.title"),
        icon: ChurchIcon,
        options: OPTIONS.RELIGIOUS,
    },
    {
        key: "religion",
        title: null,
        label: null,
        icon: null,
        options: OPTIONS.RELIGIONS,
        visible: (profile) => profile.religious === "yes",
    },
];

export const USER_LIFESTYLE = [
    {
        key: "pets",
        title: t("user.profile_overview.characteristic.pets.title"),
        label: t("user.profile_overview.characteristic.pets.label"),
        icon: DogLeashedIcon,
    },
    {
        key: "smoke_regular",
        title: t("user.profile_overview.characteristic.smoke_regular.title"),
        label: t("user.profile_overview.characteristic.smoke_regular.label"),
        icon: SmokingIcon,
    },
    {
        key: "drink_regular",
        title: t("user.profile_overview.characteristic.drink_regular.title"),
        label: t("user.profile_overview.characteristic.drink_regular.label"),
        icon: CocktailIcon,
    },
    {
        key: "sport_regular",
        title: t("user.profile_overview.characteristic.sport_regular.title"),
        label: t("user.profile_overview.characteristic.sport_regular.label"),
        icon: RunningPersonIcon,
    },
    {
        key: "sport",
        title: t("user.profile_overview.characteristic.sport.title"),
        label: t("user.profile_overview.characteristic.sport.label"),
        icon: BasketballIcon,
    },
    {
        key: "food",
        title: t("user.profile_overview.characteristic.food.title"),
        label: t("user.profile_overview.characteristic.food.label"),
        icon: SoupIcon,
    },
    {
        key: "holiday",
        title: t("user.profile_overview.characteristic.holiday.title"),
        label: t("user.profile_overview.characteristic.holiday.label"),
        icon: interestsIcons["EarthIcon"],
    },
    {
        key: "music",
        title: t("user.profile_overview.characteristic.music.title"),
        label: t("user.profile_overview.characteristic.music.label"),
        icon: interestsIcons["NoteIcon"],
    },
    {
        key: "instruments",
        title: t("user.profile_overview.characteristic.instruments.title"),
        label: t("user.profile_overview.characteristic.instruments.label"),
        icon: interestsIcons["DoubleNoteIcon"],
    },
];

export const USER_LIFESTYLE_EDIT_ITEMS = [
    {
        key: "pet",
        title: t("user.profile_overview.characteristic.pets.title"),
        icon: DogLeashedIcon,
        options: OPTIONS.PETS,
    },
    {
        key: "smoke_regular",
        title: t("user.profile_overview.characteristic.smoke_regular.title"),
        icon: SmokingIcon,
        options: OPTIONS.SMOKER,
    },
    {
        key: "drink_regular",
        title: t("user.profile_overview.characteristic.drink_regular.title"),
        icon: CocktailIcon,
        options: OPTIONS.DRINKER,
    },
    {
        key: "sport_regular",
        title: t("user.profile_overview.characteristic.sport_regular.title"),
        icon: RunningPersonIcon,
        options: OPTIONS.SPORT_REGULARITY,
    },
    {
        key: "sport",
        title: t("user.profile_overview.characteristic.sport.title"),
        icon: BasketballIcon,
        options: OPTIONS.SPORT_TYPES,
    },
    {
        key: "food",
        title: t("user.profile_overview.characteristic.food.title"),
        icon: SoupIcon,
        options: OPTIONS.FOOD,
    },
    {
        key: "holiday",
        title: t("user.profile_overview.characteristic.holiday.title"),
        icon: interestsIcons["EarthIcon"],
        options: OPTIONS.HOLIDAY,
    },
    {
        key: "music",
        title: t("user.profile_overview.characteristic.music.title"),
        icon: interestsIcons["NoteIcon"],
        options: OPTIONS.MUSIC,
    },
    {
        key: "instruments",
        title: t("user.profile_overview.characteristic.instruments.title"),
        icon: interestsIcons["DoubleNoteIcon"],
        options: OPTIONS.INSTRUMENTS,
    },
];

export const USER_PROFILE_DEFINITION = [
    {
        key: "location",
    },
    {
        key: "education",
        label: t("user.profile_overview.characteristic.education.label"),
        icon: EducationIcon,
        form: EducationForm,
        hasDropdown: true,
    },
    {
        key: "marital_status",
        label: t("user.profile_overview.characteristic.marital_status.label"),
        icon: RingsWeddingIcon,
        form: MaritalStatusForm,
    },
    {
        key: "children_number",
        label: t("user.profile_overview.characteristic.children_number.label"),
        icon: BabyStrollerIcon,
        form: KidsForm,
        hasDropdown: true,
    },
    {
        key: "wants_kids",
        label: t("user.profile_overview.characteristic.wants_kids.label"),
        icon: BabyOutlineIcon,
        form: KidsDesireForm,
    },
    {
        key: "height",
        label: t("user.profile_overview.characteristic.height.label"),
        icon: HeightIcon,
    },
    {
        key: "smoke_regular",
        label: t("user.profile_overview.characteristic.smoke_regular.label"),
        icon: SmokingIcon,
        form: SmokingHabitForm,
    },
    {
        key: "sport_regular",
        label: t("user.profile_overview.characteristic.sport_regular.label"),
        icon: BasketballIcon,
        form: SportRegularityForm,
    },
    {
        key: "pets",
        label: t("user.profile_overview.characteristic.pets.label"),
        icon: DogLeashedIcon,
        form: PetsForm,
    },
    {
        key: "language",
        label: t("user.profile_overview.characteristic.language.label"),
        icon: GlobeOutlineIcon,
        form: LanguageForm,
    },
    {
        key: "religion",
        label: t("user.profile_overview.characteristic.religion.label"),
        icon: ChurchIcon,
        form: ReligionForm,
    },
    {
        key: "zodiac_sign",
        label: t("user.profile_overview.characteristic.zodiac"),
    },
];

const FILTER_OPTIONS = Object.freeze({
    premiumStates: [
        {
            text: "Non Premium",
            value: "non_premium",
        },
        {
            text: "Potential Premium Free",
            value: "potential_premium_free",
        },
        {
            text: "Premium Free Pending",
            value: "premium_free_pending",
        },
        {
            text: "Premium Free",
            value: "premium_free",
        },
        {
            text: "Premium Paid",
            value: "premium",
        },
        {
            text: "Premium Trial",
            value: "premium_trial",
        },
    ],
    accountStates: [
        {
            text: "Banned",
            value: "banned",
        },
        {
            text: "Not Banned",
            value: "not_banned",
        },
        {
            text: "Reported",
            value: "reported",
        },
        {
            text: "Deactivated",
            value: "deactivated",
        },
        {
            text: "Deleted",
            value: "deleted",
        },
    ],
    scamIndicators: [
        {
            text: "Message Limit Reached",
            value: "flagged_for_too_many_chats",
        },
        {
            text: "Too Many Messages/Minute",
            value: "flagged_for_too_many_first_messages",
        },
        {
            text: "Browser Lang",
            value: "has_spammer_browser_language",
        },
        {
            text: "No CID",
            value: "does_not_have_cid",
        },
        {
            text: "Pay By Transfer",
            value: "purchase_via_transfer",
        },
        {
            text: "Time To Purchase",
            value: "purchase_too_soon",
        },
        {
            text: "Purchase w/o Promo",
            value: "purchase_without_promo",
        },
        {
            text: "Deactivated Early",
            value: "deactivated_too_early",
        },
        {
            text: "Too many Rejections",
            value: "too_many_rejections",
        },
        {
            text: "Duplicate Phone",
            value: "duplicate_phone_number",
        },
        {
            text: "Notifications Off",
            value: "notifications_toggled_after_register",
        },
        {
            text: "Question Game Copy Paste",
            value: "question_game_copy_paste",
        },
    ],
});

export const MICROPAYMENT_SUCCESS_ITEMS = [
    {
        key: "spotlight",
        modal_title: t(
            "paywall.contextual.spotlight.success_modal.modal_title"
        ),
        modal_subtitle: t(
            "paywall.contextual.spotlight.success_modal.modal_subtitle"
        ),
        title: "paywall.contextual.spotlight.product_name",
        icon: markRaw(LightningBoltIconSolid),
        subtitle: "paywall.contextual.spotlight.success_modal.subtitle",
        explanation: t(
            "paywall.contextual.spotlight.success_modal.explanation"
        ),
        cta_text: t("paywall.contextual.spotlight.success_modal.cta_text"),
        cancel_text: t(
            "paywall.contextual.spotlight.success_modal.cancel_text"
        ),
        confirm_action: route("consumables.activate.consumable.item", {
            item: "spotlight",
        }),
        action_method: "post",
    },
    {
        key: "privacy_plus",
        modal_title: t(
            "paywall.contextual.privacy_plus.success_modal.modal_title"
        ),
        modal_subtitle: t(
            "paywall.contextual.privacy_plus.success_modal.modal_subtitle"
        ),
        title: "paywall.product_privacy_plus",
        icon: markRaw(LockIcon),
        subtitle: null,
        explanation: t(
            "paywall.contextual.privacy_plus.success_modal.explanation"
        ),
        cta_text: t("paywall.contextual.privacy_plus.success_modal.cta_text"),
        confirm_action: route("user.settings.view.privacy"),
        action_method: "get",
    },
];

export const REWARDS = [
    {
        key: "dailys",
        title: t("rewards.dropdown.dailys.title"),
        framedIcons: false,
        items: [
            {
                key: "visit_partners",
                title: t("rewards.dropdown.dailys.visit_partners.title"),
                icon: markRaw(UserOnCardsIcon),
                amount: 5,
                complete: false,
            },
            {
                key: "compliment_partners",
                title: t("rewards.dropdown.dailys.compliment_partners.title"),
                icon: markRaw(LikeIcon),
                amount: 10,
                complete: false,
            },
            {
                key: "message_partners",
                title: t("rewards.dropdown.dailys.message_partners.title"),
                icon: markRaw(AirplaneTiltedOutlineIcon),
                amount: 10,
                complete: false,
            },
            {
                key: "answer_partners",
                title: t("rewards.dropdown.dailys.answer_partners.title"),
                icon: markRaw(CommentIcon),
                amount: 10,
                complete: false,
            },
        ],
    },
    {
        key: "activities",
        title: t("rewards.dropdown.activities.title"),
        framedIcons: false,
        items: [
            {
                key: "active_one_day",
                title: t("rewards.dropdown.activities.active_one_day.title"),
                text: t("rewards.dropdown.activities.active_one_day.text"),
                amount: 1,
                complete: false,
            },
            {
                key: "active_seven_days",
                title: t("rewards.dropdown.activities.active_seven_days.title"),
                text: t("rewards.dropdown.activities.active_seven_days.text"),
                amount: 20,
                complete: false,
            },
            {
                key: "active_twenty_eight_days",
                title: t(
                    "rewards.dropdown.activities.active_twenty_eight_days.title"
                ),
                text: t(
                    "rewards.dropdown.activities.active_twenty_eight_days.text"
                ),
                amount: 50,
                complete: false,
            },
        ],
    },
    {
        key: "onetime",
        title: t("rewards.dropdown.onetime.title"),
        framedIcons: true,
        items: [
            {
                key: "fifty_percent_profile_completion",
                title: t(
                    "rewards.dropdown.onetime.fifty_percent_profile_completion.title"
                ),
                text: t(
                    "rewards.dropdown.onetime.fifty_percent_profile_completion.text"
                ),
                icon: markRaw(StarIcon),
                amount: 100,
                complete: false,
            },
            {
                key: "hundred_percent_profile_completion",
                title: t(
                    "rewards.dropdown.onetime.hundred_percent_profile_completion.title"
                ),
                text: t(
                    "rewards.dropdown.onetime.hundred_percent_profile_completion.text"
                ),
                icon: markRaw(RisingStarIcon),
                amount: 300,
                complete: false,
            },
            {
                key: "become_premium_member",
                title: "rewards.dropdown.onetime.become_premium_member.title",
                title_link: t(
                    "rewards.dropdown.onetime.become_premium_member.title_link"
                ),
                title_link_route: route("paywall.select.product"),
                text: t("rewards.dropdown.onetime.become_premium_member.text"),
                icon: markRaw(SwanDarkIcon),
                amount: 3000,
                complete: false,
            },
        ],
    },
];

export const REWARD_INFO_WIDGETS = [
    {
        icon: markRaw(CupStarIcon),
        stampedIcon: false,
        title: t("rewards.popover_menu.info_widgets.widget_2.title"),
        explanation: "rewards.popover_menu.info_widgets.widget_2.explanation",
        hyperLinkLabel: t(
            "rewards.popover_menu.info_widgets.widget_2.hyperlink_label"
        ),
        hyperLinkRoute: route("user.settings.view.rewards"),
    },
    {
        icon: markRaw(HandStarsIcon),
        stampedIcon: true,
        title: t("rewards.popover_menu.info_widgets.widget_3.title"),
        explanation: "rewards.popover_menu.info_widgets.widget_3.explanation",
        hyperLinkLabel: t(
            "rewards.popover_menu.info_widgets.widget_3.hyperlink_label"
        ),
        hyperLinkRoute: route("user.settings.view.rewards"),
    },
    {
        icon: markRaw(HandHeartIcon),
        stampedIcon: false,
        title: t("rewards.popover_menu.info_widgets.widget_1.title"),
        explanation: "rewards.popover_menu.info_widgets.widget_1.explanation",
        hyperLinkLabel: t(
            "rewards.popover_menu.info_widgets.widget_1.hyperlink_label"
        ),
        hyperLinkRoute: route("user.settings.view.rewards"),
    },
];

export const COIN_BALANCE_ITEMS = [
    {
        key: "coin_balance",
        title: t("rewards.area.balance.available.title"),
        cta: t("rewards.area.balance.available.cta"),
    },
    {
        key: "coins_collected_today",
        title: t("rewards.area.balance.collected_today.title"),
        cta: t("rewards.area.balance.collected_today.cta"),
    },
    {
        key: "coins_collected_alltime",
        title: t("rewards.area.balance.collected_alltime.title"),
        cta: null,
    },
];

export const MISSING_COINS_BALANCE_ITEMS = [
    {
        key: "spotlight",
        icon: markRaw(LightningBoltIcon),
        disclaimer: t(
            "consumables.spotlight.missing_coin_balance_modal.disclaimer"
        ),
        explanation: t(
            "consumables.spotlight.missing_coin_balance_modal.explanation"
        ),
    },
    {
        key: "premium",
        icon: markRaw(SwanIcon),
        disclaimer: t(
            "consumables.premium_three_days.missing_coin_balance_modal.disclaimer"
        ),
        explanation: t(
            "consumables.premium_three_days.missing_coin_balance_modal.explanation"
        ),
    },
    {
        key: "send_rose",
        icon: markRaw(RoseIcon),
        disclaimer: t(
            "consumables.send_rose.missing_coin_balance_modal.disclaimer"
        ),
        explanation: t(
            "consumables.send_rose.missing_coin_balance_modal.explanation"
        ),
    },
    {
        key: "compliment",
        icon: markRaw(StylizedHeartIcon),
        disclaimer: t(
            "consumables.compliment.missing_coin_balance_modal.disclaimer"
        ),
        explanation: t(
            "consumables.compliment.missing_coin_balance_modal.explanation"
        ),
    },
    {
        key: "exclusive_message",
        icon: markRaw(ExclusiveMessageIcon),
        disclaimer: t(
            "consumables.exclusive_message.missing_coin_balance_modal.disclaimer"
        ),
        explanation: t(
            "consumables.exclusive_message.missing_coin_balance_modal.explanation"
        ),
    },
];

export const MICROTRANSACTION_ITEMS = [
    {
        context: "compliment",
        icon: markRaw(StylizedHeartIcon),
        price: 100,
        messengerAttr: {
            text: t("profile.ls_functions_make_compliment_short"),
            placeholder: t(
                `consumables.compliment.messenger.placeholder.${
                    grid.md ? "desktop" : "mobile"
                }`
            ),
        },
    },
    {
        context: "send_rose",
        icon: markRaw(RoseIcon),
        price: 200,
        messengerAttr: {
            text: t("profile.ls_functions_send_rose_short"),
            placeholder: t(
                `consumables.send_rose.messenger.placeholder.${
                    grid.md ? "desktop" : "mobile"
                }`
            ),
        },
    },
    {
        context: "exclusive_message",
        icon: markRaw(ExclusiveMessageIcon),
        price: 400,
        messengerAttr: {
            text: t("profile.ls_functions_exclusive_message"),
            placeholder: t(
                `consumables.exclusive_message.messenger.placeholder.${
                    grid.md ? "desktop" : "mobile"
                }`
            ),
        },
    },
    {
        context: "spotlight_1_via_coins",
        icon: markRaw(LightningBoltIconSolid),
        price: 990,
        confirmAction: () =>
            router.post(
                route("consumables.activate.consumable.item", {
                    item: "spotlight",
                }),
                {},
                {
                    preserveScroll: true,
                }
            ),
    },
    {
        context: "premium_three_days",
        icon: markRaw(SwanIcon),
        price: 2000,
        confirmAction: () =>
            router.post(
                route("consumables.activate.consumable.item", {
                    item: "premium_three_days",
                }),
                {},
                { preserveScroll: true }
            ),
    },
    {
        context: "premium_seven_days",
        icon: markRaw(SwanIcon),
        price: 4500,
    },
    // {
    //     context: "privacy_plus",
    //     icon: markRaw(LockIcon),
    //     price: 690,
    // },
    // {
    //     context: "horoscope",
    //     icon: markRaw(HoroscopeIcon),
    //     price: 690,
    // },
];

export const FIRST_POTENTIAL_MESSAGE_ITEMS = [
    {
        context: "share_photos",
        icon: markRaw(PhotosIcon),
    },
    {
        context: "send_smile",
        icon: markRaw(SmileIcon),
    },
    {
        context: "send_rose",
        icon: markRaw(RoseIcon),
        price: 200,
    },
    {
        context: "compliment",
        icon: markRaw(StylizedHeartIcon),
        price: 100,
    },
    {
        context: "exclusive_message",
        icon: markRaw(ExclusiveMessageIcon),
        price: 400,
    },
];

export const ADDON_ITEMS = [
    {
        context: "spotlight",
        icon: markRaw(LightningBoltIconSolid),
        isRuntimeProduct: false,
    },
    {
        context: "privacy_plus",
        icon: markRaw(LockIcon),
        isRuntimeProduct: true,
    },
    {
        context: "premium_state",
        icon: markRaw(SwanIcon),
        isRuntimeProduct: true,
    },
    {
        context: "coins",
        icon: SwanIcon,
        isRuntimeProduct: false,
    },
];

export const LIKE_TYPES = {
    avatar: "like_avatar",
    photo: "like_photo",
    photos: "like_photos",
    welcomeMessage: "like_welcome_message",
    characteristic: "like_characteristics",
    aboutMeAnswers: "like_about_me",
    favoriteTrack: "like_favorite_track",
    favoriteArtists: "like_favorite_artists",
    interests: "like_interests",
    lifestyle: "like_lifestyle",
    commalities: "like_commonalities",
};

export const REPORT_TYPES = {
    photo: "misguided_photo",
    contact: "profile_contain_hidden_contact",
    offensive: "user_is_offensive",
    message: "message_is_sexually_offensive",
    fraudulent: "user_has_fraudulent_intention",
    other: "other",
};

export const MESSENGER_ICONS = {
    share_whats_app: markRaw(WhatsAppLogo),
    share_phone_number: markRaw(CirclePhoneIcon),
    share_email: markRaw(CircleMailIcon),
    like_avatar: markRaw(LikeIcon),
    like_photo: markRaw(LikeIcon),
    like_photos: markRaw(LikeIcon),
    like_about_me: markRaw(LikeIcon),
    like_description: markRaw(LikeIcon),
    like_welcome_message: markRaw(LikeIcon),
    like_personal_quote: markRaw(LikeIcon),
    like_sport: markRaw(LikeIcon),
    like_hobby: markRaw(LikeIcon),
    like_music: markRaw(LikeIcon),
    like_leisure_time: markRaw(LikeIcon),
    like_instruments: markRaw(LikeIcon),
    like_food: markRaw(LikeIcon),
    like_holiday: markRaw(LikeIcon),
    like_characteristics: markRaw(LikeIcon),
    like_favorite_track: markRaw(LikeIcon),
    like_favorite_artists: markRaw(LikeIcon),
    like_profile: markRaw(LikeIcon),
    like_interests: markRaw(LikeIcon),
    like_lifestyle: markRaw(LikeIcon),
    like_commonalities: markRaw(LikeIcon),
    smiley: markRaw(SmileIcon),
    share_my_photo: markRaw(PhotosIcon),
    asked_for_profile_information: markRaw(QuestionMarkInCircleIcon),
    sent_exclusive_message: markRaw(ExclusiveMessageIcon),
    made_compliment: markRaw(StylizedHeartIcon),
    sent_rose: markRaw(RoseIcon),
    warning: markRaw(DangerIcon),
    ended_contact: markRaw(WavingHandInChatBubbleIcon),
    say_hello: markRaw(WavingHandIcon),
};

export const ATTACHED_MESSENGER_ICONS = {
    sent_rose: markRaw(StylizedRoseIcon),
};

export const INBOX_CHANNEL_ICONS = {
    sent_rose: markRaw(RoseIcon),
    made_compliment: markRaw(StylizedHeartIcon),
    sent_exclusive_message: markRaw(LightningBoltGoldIcon),
};

export const NOTIFICATION_FORM_CARD_ITEMS = [
    {
        key: "notifications_of_partners",
        leftHandItems: [
            {
                key: "new_prospects",
                label: "ls_my_profile_data_and_settings_communication_setting3",
            },
            {
                key: "profile_content_enquiries",
                label: "ls_my_profile_data_and_settings_communication_setting14",
            },
            {
                key: "smiles_and_likes",
                label: "ls_my_profile_data_and_settings_communication_setting2",
            },
            {
                key: "welcomes_messages",
                label: "ls_my_profile_data_and_settings_communication_setting7",
            },
        ],
        rightHandItems: [
            {
                key: "new_messages",
                label: "ls_my_profile_data_and_settings_communication_setting1",
            },
            {
                key: "compliments",
                label: "ls_my_profile_data_and_settings_communication_setting15",
            },
            {
                key: "roses",
                label: "ls_my_profile_data_and_settings_communication_setting16",
            },
            {
                key: "exclusive_messages",
                label: "ls_my_profile_data_and_settings_communication_setting17",
            },
        ],
    },
    {
        key: "proposals_and_matching",
        leftHandItems: [
            {
                key: "suitable_partner_suggestions",
                label: "ls_my_profile_data_and_settings_communication_setting4",
            },
        ],
        rightHandItems: [
            {
                key: "rating_reminder",
                label: "ls_my_profile_data_and_settings_communication_setting12",
            },
        ],
    },
    {
        key: "notifications_of_favorites",
        leftHandItems: [
            {
                key: "favorite_update",
                label: "ls_my_profile_data_and_settings_communication_setting9",
            },
        ],
        rightHandItems: [],
    },
    {
        key: "horoscope",
        leftHandItems: [
            {
                key: "daily_horoscope",
                label: "ls_my_profile_data_and_settings_communication_setting13",
            },
        ],
        rightHandItems: [],
    },
    {
        key: "notifications_of_balances",
        leftHandItems: [
            {
                key: "spotlight",
                label: "ls_my_profile_data_and_settings_communication_setting11",
            },
        ],
        rightHandItems: [
            {
                key: "coins",
                label: "ls_my_profile_data_and_settings_communication_setting18",
            },
        ],
    },
    {
        key: "tips_and_information",
        leftHandItems: [
            {
                key: "tips_for_your_partner_search",
                label: "ls_my_profile_data_and_settings_communication_setting5",
            },
            {
                key: "weekly_summary",
                label: "ls_my_profile_data_and_settings_communication_setting10",
            },
        ],
        rightHandItems: [
            {
                key: "newsletter",
                label: "ls_my_profile_data_and_settings_communication_setting6",
            },
            {
                key: "attractive_offers",
                label: "ls_my_profile_data_and_settings_communication_setting8",
            },
        ],
    },
];

export const INCOGNITO_EXPLANATION_TEXT_ITEMS = [
    {
        header: "profile.incognito_modal.explanation_header_1",
        text: "profile.incognito_modal.explanation_text_1",
    },
    {
        header: "profile.incognito_modal.explanation_header_2",
        text: "profile.incognito_modal.explanation_text_2",
    },
    {
        header: "profile.incognito_modal.explanation_header_3",
        text: "profile.incognito_modal.explanation_text_3",
    },
];

export const MEMBERSHIP_INCLUSIVES = (comparison) => {
    if (comparison === "end_contract") {
        return Object.freeze({
            lite: { spotlight: 0, coins: 0, privacy_plus: false },
            basic: { spotlight: 0, coins: 0, privacy_plus: false },
            smart: { spotlight: 1, coins: 0, privacy_plus: false },
            comfort: { spotlight: 1, privacy_plus: 24, coins: 0 },
            lite_plus: { spotlight: 1, coins: 1000, privacy_plus: false },
            basic_plus: { spotlight: 1, coins: 1000, privacy_plus: false },
            smart_plus: { spotlight: 2, coins: 1000, privacy_plus: false },
            comfort_plus: { spotlight: 2, coins: 1000, privacy_plus: 24 },
        });
    }

    if (comparison === "tariff_switch") {
        return Object.freeze({
            smart: { spotlight: 1 },
            comfort: { spotlight: 1, privacy_plus: 24 },
            lite_plus: { spotlight: 1, coins: 1000 },
            basic_plus: { spotlight: 1, coins: 1000 },
            smart_plus: { spotlight: 2, coins: 1000 },
            comfort_plus: { spotlight: 2, coins: 1000, privacy_plus: 24 },
        });
    }

    if (comparison === "tariff_extension") {
        return Object.freeze({
            lite: { coins: 0, spotlight: 0 },
            basic: { coins: 0, spotlight: 0 },
            smart: { coins: 0, spotlight: 1 },
            comfort: { coins: 0, spotlight: 1, privacy_plus: 24 },
            lite_plus: { spotlight: 1, coins: 1000 },
            basic_plus: { spotlight: 1, coins: 1000 },
            smart_plus: { spotlight: 2, coins: 1000 },
            comfort_plus: { spotlight: 2, coins: 1000, privacy_plus: 24 },
        });
    }

    return Object.freeze({
        lite: { coins: 0, spotlight: 0 },
        basic: { coins: 0, spotlight: 0 },
        smart: { coins: 0, spotlight: 1 },
        comfort: { coins: 0, spotlight: 1 },
    });
};

export const NON_MEMBERSHIP_INCLUSIVES = (count) =>
    Object.freeze({
        coins_plus: { coins: count },
        spotlight_plus: { spotlight: count },
        privacy_plus: { privacy_plus: count },
        plus_upgrade: { coins: 1000, spotlight: 1 },
    });

export const MEMBERSHIP_PLUS_BENEFITS = Object.freeze({
    lite: { coins: 1000, spotlight: 1 },
    basic: { coins: 1000, spotlight: 1 },
    smart: { coins: 1000, spotlight: 2 },
    comfort: { coins: 1000, spotlight: 2 },
});

export const COINS_PLUS_ITEMS = [
    {
        code: "coins_plus_0",
        text: t("paywall.ls_paywall_upgrade.items.no_items", {
            item: t("paywall.contextual.coins.product_name"),
        }),
        value: 0,
    },
    {
        code: "coins_plus_1000",
        text: t("paywall.contextual.coins.price_point_name", {
            count: 1000,
        }),
        value: 1000,
    },
    {
        code: "coins_plus_3000",
        text: t("paywall.contextual.coins.price_point_name", {
            count: 3000,
        }),
        value: 3000,
    },
];

export const SPOTLIGHT_PLUS_ITEMS = (spotlightIncluded) => [
    {
        code: "spotlight_plus_0",
        text: spotlightIncluded
            ? t("paywall.ls_paywall_upgrade.items.x_items", {
                  count: 1,
                  item: t("paywall.contextual.spotlight.product_name"),
              })
            : t("paywall.ls_paywall_upgrade.items.no_item", {
                  item: t("paywall.contextual.spotlight.product_name"),
              }),
        value: 0,
        inclusive: spotlightIncluded,
    },
    {
        code: "spotlight_plus_1",
        text: t("paywall.ls_paywall_upgrade.items.x_items", {
            count: spotlightIncluded ? 2 : 1,
            item: t("paywall.contextual.spotlight.product_name"),
        }),
        value: 1,
    },
    {
        code: "spotlight_plus_2",
        text: t("paywall.ls_paywall_upgrade.items.x_items", {
            count: spotlightIncluded ? 3 : 2,
            item: t("paywall.contextual.spotlight.product_name"),
        }),
        value: 2,
    },
];

export const PRIVACY_PLUS_ITEMS = [
    {
        code: "privacy_plus_0",
        text: t("paywall.ls_paywall_upgrade.items.no_items", {
            item: t("paywall.contextual.privacy_plus.label"),
        }),
        value: 0,
    },
    {
        code: "privacy_plus_6",
        text: t("paywall.contextual.privacy_plus.product_name", {
            count: 6,
        }),
        value: 6,
    },
    {
        code: "privacy_plus_12",
        text: t("paywall.contextual.privacy_plus.product_name", {
            count: 12,
        }),
        value: 12,
    },
];

export const PLUS_UPGRADE_ITEMS = Object.freeze({
    coinsPlus: {
        code: "plus_upgrade_coins",
        anchorPrice: 8.99,
    },
    spotlightPlus: {
        code: "plus_upgrade_spotlight",
        anchorPrice: 6.99,
    },
});

export const ANCHOR_PRICES = Object.freeze({
    coins_plus_500: 4.99,
    coins_plus_1000: 8.99,
    coins_plus_3000: 19.99,
    spotlight_plus_1: 6.9,
    spotlight_plus_2: 9.9,
    spotlight_plus_3: 14.9,
    privacy_plus: 6.9,
    plus_upgrade: 15.98,
});

export const INTERESTS = [
    { value: "architecture", icon: markRaw(interestsIcons["CircleIcon"]) },
    { value: "going_out", icon: markRaw(interestsIcons["SpeechBubblesIcon"]) },
    { value: "cars", icon: markRaw(interestsIcons["CarIcon"]) },
    { value: "baking", icon: markRaw(interestsIcons["BreadIcon"]) },
    { value: "blogging", icon: markRaw(interestsIcons["TextIcon"]) },
    { value: "clubbing", icon: markRaw(interestsIcons["SoundWaveIcon"]) },
    { value: "comedy", icon: markRaw(interestsIcons["PacmanIcon"]) },
    { value: "cosplay", icon: markRaw(interestsIcons["UwuIcon"]) },
    { value: "diy", icon: markRaw(interestsIcons["WrenchIcon"]) },
    { value: "volunteering", icon: markRaw(interestsIcons["HeartAndDotIcon"]) },
    { value: "relaxing", icon: markRaw(interestsIcons["PeaceIcon"]) },
    { value: "family", icon: markRaw(interestsIcons["PeopleIcon"]) },
    { value: "film_video", icon: markRaw(interestsIcons["TVIcon"]) },
    { value: "festivals", icon: markRaw(interestsIcons["SubwooferIcon"]) },
    { value: "photography", icon: markRaw(interestsIcons["CameraIcon"]) },
    { value: "meeting_friends", icon: markRaw(interestsIcons["SmileyIcon"]) },
    { value: "gaming", icon: markRaw(interestsIcons["ControllerIcon"]) },
    { value: "gardening", icon: markRaw(interestsIcons["PlantIcon"]) },
    {
        value: "carpentry_mechanics",
        icon: markRaw(interestsIcons["HouseIcon"]),
    },
    { value: "board_games", icon: markRaw(interestsIcons["DicesIcon"]) },
    { value: "history", icon: markRaw(interestsIcons["StudyBookIcon"]) },
    { value: "playing_in_a_band", icon: markRaw(interestsIcons["NoteIcon"]) },
    { value: "interior_design", icon: markRaw(interestsIcons["CouchIcon"]) },
    {
        value: "playing_an_instrument",
        icon: markRaw(interestsIcons["NoteWithSparklesIcon"]),
    },
    { value: "internet", icon: markRaw(interestsIcons["EthernetGlobeIcon"]) },
    { value: "cinema", icon: markRaw(interestsIcons["MovieCameraIcon"]) },
    {
        value: "climate_environmental_protection",
        icon: markRaw(interestsIcons["EarthIcon"]),
    },
    { value: "cooking", icon: markRaw(interestsIcons["TableBellIcon"]) },
    { value: "cooking_classes", icon: markRaw(interestsIcons["CutleryIcon"]) },
    { value: "concerts", icon: markRaw(interestsIcons["TicketsIcon"]) },
    { value: "art", icon: markRaw(interestsIcons["GeometricFormsIcon"]) },
    { value: "reading_literature", icon: markRaw(interestsIcons["BookIcon"]) },
    { value: "painting_drawing", icon: markRaw(interestsIcons["PencilIcon"]) },
    { value: "meditation", icon: markRaw(interestsIcons["DottedCircleIcon"]) },
    { value: "medicine", icon: markRaw(interestsIcons["MedKitIcon"]) },
    { value: "fashion", icon: markRaw(interestsIcons["NecktieIcon"]) },
    { value: "motorcycles", icon: markRaw(interestsIcons["MotorcycleIcon"]) },
    { value: "music", icon: markRaw(interestsIcons["DoubleNoteIcon"]) },
    { value: "nature", icon: markRaw(interestsIcons["BlossomIcon"]) },
    { value: "podcasts", icon: markRaw(interestsIcons["RadioIcon"]) },
    { value: "politics", icon: markRaw(interestsIcons["AcropolisIcon"]) },
    { value: "psychology", icon: markRaw(interestsIcons["ClipboardIcon"]) },
    { value: "traveling", icon: markRaw(interestsIcons["CrossRoadsIcon"]) },
    { value: "writing", icon: markRaw(interestsIcons["InkPenIcon"]) },
    { value: "social_media", icon: markRaw(interestsIcons["SmartphoneIcon"]) },
    { value: "walking", icon: markRaw(interestsIcons["BloomingPlantsIcon"]) },
    { value: "game_nights", icon: markRaw(interestsIcons["DicesIcon"]) },
    { value: "sports", icon: markRaw(interestsIcons["BycicleIcon"]) },
    {
        value: "languages",
        icon: markRaw(interestsIcons["SmileyOpenMouthIcon"]),
    },
    { value: "dancing", icon: markRaw(interestsIcons["DancingCoupleIcon"]) },
    { value: "tech_it", icon: markRaw(interestsIcons["ProcessorIcon"]) },
    { value: "theater", icon: markRaw(interestsIcons["TheatreMasksIcon"]) },
    { value: "animals", icon: markRaw(interestsIcons["PawIcon"]) },
    { value: "pottery", icon: markRaw(interestsIcons["ClayPotIcon"]) },
    { value: "wine", icon: markRaw(interestsIcons["WineGlassIcon"]) },
    { value: "wellness", icon: markRaw(interestsIcons["SteamIcon"]) },
    {
        value: "economics",
        icon: markRaw(interestsIcons["IncreasingChartsIcon"]),
    },
    {
        value: "science",
        icon: markRaw(interestsIcons["GlobeWithAcademicCapIcon"]),
    },
];

export const CONTRACT_TYPES = Object.freeze({
    privacy_plus: "privacy_plus",
    coins_plus: "coins_plus",
    spotlight_plus: "spotlight_plus",
    plus_upgrade: "plus_upgrade",
    plus_membership: "plus_membership",
    membership: "membership",
});

export const CONTRACT_STATES = Object.freeze({
    active: "active",
    inTermination: "in-termination",
    terminated: "terminated",
    inDissolving: "in-dissolving",
    dissolved: "dissolved",
    discontinued: "discontinued",
    revoked: "revoked",
});

export const PAYMENT_METHODS_WITHOUT_DETAILS = [
    "Amazon Pay",
    "Online Überweisung",
    "Sofort bezahlen mit Klarna.",
    "Google Pay",
];

export const ALTERNATE_PAYMENT_METHODS = ["giropay", "transfer"];

export const REJECTION_REASONS = [
    {
        text: t("user.rejection_reason_modal.reasons.reason_1"),
    },
    {
        text: t("user.rejection_reason_modal.reasons.reason_2"),
    },
    {
        text: t("user.rejection_reason_modal.reasons.reason_3"),
    },
    {
        text: t("user.rejection_reason_modal.reasons.reason_4"),
    },
    {
        text: t("user.rejection_reason_modal.reasons.reason_5"),
    },
];

export {
    ROUTES,
    OPTIONS,
    EMAIL_PROVIDERS,
    EMAIL_ADDRESSES,
    MESSENGER_AND_EMAIL_LINKS,
    SOCIAL_MEDIA_LINKS,
    FEATURES,
    PTRIAL_FEATURES,
    FILTER_OPTIONS,
    PREMIUM_INFORMATION,
    COUNTRY_AREA_CODES,
    APP_CONFIG,
    TOAST_STATES,
    LIMIT_FOR_PHOTOS_UPLOAD,
};
